export const GET_COUNTRY_LIST_START = 'GET_COUNTRY_LIST_START';
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS';
export const GET_COUNTRY_LIST_ERROR = 'GET_COUNTRY_LIST_ERROR';
export const GET_COUNTRY_LIST_END = 'GET_COUNTRY_LIST_END';

export const GET_PROVIDERS_START = 'GET_PROVIDERS_START';
export const GET_PROVIDERS_SUCCESS = 'GET_PROVIDERS_SUCCESS';
export const GET_PROVIDERS_ERROR = 'GET_PROVIDERS_ERROR';
export const GET_PROVIDERS_END = 'GET_COUNTRY_LIST_END';
